import { IconButton, Stack, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import DisabledByDefaultOutlinedIcon from "@mui/icons-material/DisabledByDefaultOutlined";
import { ConfirmPopup } from "src/shared/components/confirm-popup";
import { useEffect, useState } from "react";
import { useUpdateSubscriptionMutation } from "src/api/customers";
import { useRecoilState } from "recoil";
import { notificationsState } from "src/store/notifications";

const TableActions = ({
  rowId,
  rowName,
  refetch,
  rowStatus,
}: {
  rowId: string;
  rowName: string;
  refetch: Function;
  rowStatus: boolean;
}) => {
  const { t } = useTranslation("general");
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useRecoilState(notificationsState);

  // APIS
  const { mutate, isPending, status, error } = useUpdateSubscriptionMutation();

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleCancelPackage = () => {
    mutate({
      id: rowId,
      status: 0,
    });
  };

  useEffect(() => {
    if (status === "success") {
      refetch();
      handleClose();
      setNotifications([
        ...notifications,
        {
          type: "success",
          message: t("updatedSuccessfully"),
        },
      ]);
    } else if (status === "error") {
      setNotifications([
        ...notifications,
        {
          type: "error",
          message: error?.data.errors[0].value || t("somethingWrong"),
        },
      ]);
    }
  }, [status]);

  return (
    <Stack
      direction={"row"}
      spacing={"12px"}
      width={"100%"}
      justifyContent={"center"}
    >
      {rowStatus ? (
        <Tooltip title={t("cancel")}>
          <IconButton onClick={handleClickOpen}>
            <DisabledByDefaultOutlinedIcon />
          </IconButton>
        </Tooltip>
      ) : null}

      <ConfirmPopup
        open={open}
        item={""}
        handleClose={handleClose}
        handleConfirm={handleCancelPackage}
        isPending={isPending}
        title={t("cancel")}
        subtitle={t("areYouSureToConfirm")}
        confirmBtnText={t("confirm")}
      />
    </Stack>
  );
};
export default TableActions;
